/* Read-only success bus adapter. Never mutate cart UI, fetch or consent APIs. */
(function () {
  'use strict';
  var api = window.__ga4Journey, config = window.__ga4JourneyConfig || {};
  if (!api) return;
  var seen = new WeakSet(), operations = new WeakMap(), operationStates = new Set(), completed = new Set(), intents = new Map();
  var snapshot = null, revision = 0, pending = null, controller = null, epoch = 0;
  var view = null, stickyClick = false, checkoutClicks = new WeakSet();
  var removalKey = 'ga4_cart_removal_v1';
  function clearRemoval() { try { sessionStorage.removeItem(removalKey); } catch (_) {} }
  function confirmRemoval(cart) {
    var saved;
    try { saved = JSON.parse(sessionStorage.getItem(removalKey) || 'null'); } catch (_) { clearRemoval(); return; }
    if (!saved) return;
    if (saved.pageId === api.pageId()) return; // A pre-navigation read cannot confirm the remove redirect.
    clearRemoval();
    if (!api.isAllowed() || !saved.item || !valid([saved.item]) || typeof saved.key !== 'string' ||
      typeof saved.at !== 'number' || Date.now() - saved.at < 0 || Date.now() - saved.at > 60000 || saved.currency !== cart.currency) return;
    if (cart.lines.some(function (line) { return line.key === saved.key; })) { skipped('remove_from_cart', 'remove_not_confirmed'); return; }
    api.emit('remove_from_cart', { currency: cart.currency, value: value([saved.item]), items: [saved.item], cart_surface: saved.surface,
      operation_id: saved.id, origin_page_view_id: saved.pageId });
  }
  var addSelector = '[data-pm-add-cart], [data-add-to-cart], .add-to-cart, [data-bundle-add], .upsell-product__add-btn, [data-wishlist-add], [data-wishlist-add-all]';
  function skipped(name, reason) { api.noteSkipped(name, reason); }
  function cartSurface(el) {
    if (el && el.closest && el.closest('#CartDrawer, .cart-drawer')) return 'drawer';
    return config.pageType === 'cart' || document.body.classList.contains('template-cart') ? 'page' : 'storefront';
  }
  function sourceFor(el) {
    if (!el || !el.closest) return 'unknown';
    if (el.matches('[data-cart-gift-wrap-checkbox]')) return 'gift_wrap';
    if (el.closest('[data-sticky-add-to-cart]')) return 'sticky_bar';
    if (el.closest('bundle-builder')) return 'custom_bundle';
    if (el.closest('[data-wishlist-drawer]')) return 'wishlist';
    if (el.closest('[id^="QuickShop"], .quick-product__wrapper')) return 'quick_shop';
    if (el.matches('.upsell-product__add-btn')) return 'upsell_recommendations';
    if (el.closest('product-form')) return 'flex_product_form';
    if (el.matches('[data-pm-add-cart], [data-add-to-cart], .add-to-cart')) return 'main_button';
    return 'unknown';
  }
  function operation(button, form) {
    if (!api.isAllowed()) {
      // Consent barrier only: no ID, source, quantity or denied behavior is retained.
      if (button) operations.set(button, { blocked: true });
      if (form) operations.set(form, { blocked: true });
      return;
    }
    var input = form && form.elements && form.elements.namedItem('quantity');
    var op = { id: api.uuid(), source: stickyClick ? 'sticky_bar' : sourceFor(button), surface: cartSurface(button || form),
      quantity: form ? Number(input ? input.value : 1) : null, at: performance.now() };
    if (button) operations.set(button, op);
    if (form) operations.set(form, op);
    operationStates.add(op);
    if (operationStates.size > 200) {
      var oldest = operationStates.values().next().value;
      Object.keys(oldest).forEach(function (key) { delete oldest[key]; }); oldest.blocked = true;
      operationStates.delete(oldest);
    }
    stickyClick = false;
    return op;
  }
  function giftOperation(control, action, name) {
    var op = control && operations.get(control);
    if (!op) { skipped(name, 'missing_operation'); return null; }
    if (op.blocked) { skipped(name, 'operation_not_consented'); return null; }
    if (op.action !== action || performance.now() - op.at > 60000) { skipped(name, 'expired_operation'); return null; }
    if (completed.has(op.id)) { skipped(name, 'duplicate_response'); return null; }
    return op;
  }
  function item(p, quantity) {
    p = p && typeof p === 'object' ? p : {};
    return { item_id: String(p.product_id || ''), item_variant: String(p.variant_id || p.id || ''),
      item_name: p.product_title || p.title || 'unnamed', price: p.final_price == null && p.price == null ? NaN : Number(p.final_price == null ? p.price : p.final_price) / 100,
      quantity: Number(quantity) };
  }
  function valid(items) { return items.length > 0 && items.every(function (p) { return p.item_id && p.item_variant && isFinite(p.price) && p.price >= 0 && Number.isInteger(p.quantity) && p.quantity > 0; }); }
  function value(items) { return Math.round(items.reduce(function (sum, p) { return sum + p.price * p.quantity; }, 0) * 100) / 100; }
  function complete(id) {
    completed.add(id);
    if (completed.size > 200) completed.delete(completed.values().next().value);
  }
  function success(event) {
    if (!api.isAllowed()) return;
    var detail = event.detail || {}, product = detail.product || detail.response;
    if (event.type === 'wishlist:added-to-cart') product = detail.items;
    if (!product || typeof product !== 'object') { skipped('add_to_cart', 'missing_product_response'); return; }
    var button = detail.addToCartBtn, op = operations.get(button || event.target);
    if (detail.source === 'cart-gift-wrap') {
      op = giftOperation(button, 'add', 'add_to_cart');
      if (!op) return;
    }
    if (!op && event.target.matches && event.target.matches('product-form')) op = operations.get(event.target.querySelector('form'));
    if (op && op.blocked) { skipped('add_to_cart', 'operation_not_consented'); return; }
    if (op && performance.now() - op.at > 60000) op = null;
    var suppliedId = typeof detail.operation_id === 'string' && /^[a-zA-Z0-9-]{1,80}$/.test(detail.operation_id) ? detail.operation_id : null;
    var operationId = suppliedId || (op && op.id) || api.uuid();
    if (seen.has(product) || completed.has(operationId)) { skipped('add_to_cart', 'duplicate_response'); return; }
    var products = Array.isArray(product) ? product : (Array.isArray(product.items) ? product.items : [product]);
    var requested = Array.isArray(detail.items) && event.type !== 'wishlist:added-to-cart' ? detail.items : (Array.isArray(detail.requestedItems) ? detail.requestedItems : []);
    var items = products.map(function (p) {
      p = p && typeof p === 'object' ? p : {};
      var submitted = requested.find(function (entry) { return entry && String(entry.id) === String(p.variant_id || p.id); });
      var qty = submitted ? submitted.quantity : (products.length === 1 ? ((op && op.quantity) || detail.quantity || p.quantity) : p.quantity);
      // Bundle total quantity is not the quantity of every returned item.
      return item(p, qty);
    });
    if (!config.currency) { skipped('add_to_cart', 'missing_currency'); return; }
    if (!valid(items)) { skipped('add_to_cart', 'invalid_product_response'); return; }
    var source = detail.source || (op && op.source) || sourceFor(button || event.target);
    if (source === 'cart-gift-wrap') source = 'gift_wrap';
    if (event.type === 'product-form:submit:success' && source === 'unknown') source = 'flex_product_form';
    if (event.type === 'wishlist:added-to-cart') source = 'wishlist';
    if (api.emit('add_to_cart', { currency: config.currency, value: value(items), items: items, operation_id: operationId,
      add_to_cart_source: source, cart_surface: op ? op.surface : cartSurface(button || event.target) })) {
      seen.add(product); complete(operationId);
    }
    if (detail.cart) acceptCart(detail.cart, false);
    else if (view) readCart();
  }
  function safeCart(cart) {
    if (!cart || !Array.isArray(cart.items) || cart.status >= 400 || !cart.currency) return null;
    var lines = cart.items.map(function (p) {
      p = p && typeof p === 'object' ? p : {};
      return { key: p.key, item: item(p, p.quantity), automatic: !!(p.properties && p.properties._reward_gift) };
    });
    if (lines.length && !valid(lines.map(function (line) { return line.item; }))) return null;
    return { currency: cart.currency, lines: lines };
  }
  function giftRemoval(detail) {
    if (!api.isAllowed()) return;
    var op = giftOperation(detail.trigger, 'remove', 'remove_from_cart');
    if (!op) return;
    var next = safeCart(detail.cart), removed = detail.removedItems;
    if (!next || !Array.isArray(removed) || !removed.length || detail.removedCurrency !== next.currency) {
      skipped('remove_from_cart', 'invalid_product_response'); return;
    }
    var items = removed.map(function (line) { return item(line, line && line.quantity); });
    if (!valid(items) || removed.some(function (line) { return !line.key || next.lines.some(function (entry) { return entry.key === line.key; }); })) {
      skipped('remove_from_cart', 'remove_not_confirmed'); return;
    }
    if (api.emit('remove_from_cart', { currency: next.currency, value: value(items), items: items, operation_id: op.id, cart_surface: op.surface })) complete(op.id);
  }
  function emitView() {
    if (!api.isAllowed() || !view || view.sent || !snapshot || document.visibilityState === 'hidden') return;
    var items = snapshot.lines.map(function (line) { return line.item; });
    var payload = { currency: snapshot.currency, value: value(items), cart_surface: view.surface, cart_view_id: view.id,
      cart_item_count: items.reduce(function (sum, p) { return sum + p.quantity; }, 0) };
    if (items.length) payload.items = items;
    view.sent = api.emit('view_cart', payload);
  }
  function acceptCart(cart, compare) {
    if (!api.isAllowed()) return;
    var next = safeCart(cart);
    if (!next) { skipped('view_cart', 'invalid_cart_response'); return; }
    revision++;
    if (compare) intents.forEach(function (intent, key) {
      if (performance.now() - intent.at > 15000) { intents.delete(key); skipped('cart_quantity_change', 'expired_operation'); return; }
      var before = intent.before;
      var after = next.lines.find(function (line) { return line.key === key; });
      // 折扣改变会更换 Shopify 行 key；仅唯一商品/变体可回退匹配，不猜同变体多行。
      if (!after && intent.quantity > 0 && before && !before.automatic) {
        var candidates = next.lines.filter(function (line) {
          return !line.automatic && line.item.item_id === before.item.item_id && line.item.item_variant === before.item.item_variant;
        });
        if (!intent.uniqueVariant || candidates.length > 1) {
          intents.delete(key); skipped('cart_quantity_change', 'quantity_line_ambiguous'); return;
        }
        if (candidates.length === 1) after = candidates[0];
      }
      var quantity = after ? after.item.quantity : 0;
      if (!before || before.automatic || quantity !== intent.quantity || quantity === before.item.quantity || intent.currency !== next.currency) return;
      var previous = before.item.quantity, changed = Object.assign({}, quantity > previous ? after.item : before.item, { quantity: Math.abs(previous - quantity) });
      api.emit('cart_quantity_change', { currency: next.currency, product_id: changed.item_id, variant_id: changed.item_variant,
        product_title: changed.item_name, price: changed.price, changed_quantity: changed.quantity, value: value([changed]),
        cart_surface: intent.surface, operation_id: intent.id, previous_quantity: previous, quantity: quantity });
      api.emit(quantity < previous ? 'remove_from_cart' : 'add_to_cart', Object.assign({ currency: next.currency, value: value([changed]), items: [changed], cart_surface: intent.surface, operation_id: intent.id }, quantity > previous ? { add_to_cart_source: 'cart_quantity' } : {}));
      intents.delete(key);
    });
    confirmRemoval(next);
    snapshot = next; emitView();
  }
  function readCart() {
    if (!api.isAllowed() || pending) return;
    var startEpoch = epoch, startRevision = revision;
    controller = new AbortController();
    var currentController = controller, timeout = setTimeout(function () { currentController.abort(); }, 8000);
    var root = window.Shopify && Shopify.routes && Shopify.routes.root || '/';
    pending = fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' }, signal: controller.signal })
      .then(function (response) { if (!response.ok) throw new Error('cart_read_failed'); return response.json(); })
      .then(function (cart) { if (api.isAllowed() && startEpoch === epoch && startRevision === revision) acceptCart(cart, false); })
      .catch(function () { if (api.isAllowed() && startEpoch === epoch) skipped('view_cart', 'cart_read_failed'); })
      .finally(function () { clearTimeout(timeout); if (startEpoch === epoch) { pending = null; controller = null; } });
  }
  function syncView() {
    if (!api.isAllowed()) return;
    var drawer = document.querySelector('#CartDrawer');
    var drawerOpen = drawer && drawer.classList.contains('drawer--is-open') && drawer.getAttribute('aria-hidden') !== 'true';
    var surface = drawerOpen ? 'drawer' : (config.pageType === 'cart' || document.body.classList.contains('template-cart') ? 'page' : null);
    if (!surface) { view = null; return; }
    if (view && view.surface === surface) return;
    view = { id: api.uuid(), surface: surface, sent: false };
    // Always obtain current server contents for a new view; initial DOM can be stale.
    readCart();
  }
  ['ajaxProduct:added', 'product-form:submit:success', 'wishlist:added-to-cart'].forEach(function (name) { document.addEventListener(name, success); });
  ['ajaxProduct:error', 'product-form:submit:error'].forEach(function (name) {
    document.addEventListener(name, function (event) {
      if (!api.isAllowed()) return;
      var detail = event.detail || {}, op = operations.get(detail.addToCartBtn || event.target);
      if (detail.source === 'cart-gift-wrap') {
        op = giftOperation(detail.addToCartBtn, 'add', 'add_to_cart_error');
        if (!op) return;
      }
      if (op && op.blocked) return;
      var status = Number(detail.status || (detail.error && detail.error.status));
      var source = detail.source === 'cart-gift-wrap' ? 'gift_wrap' : detail.source || (op && op.source) || 'unknown';
      if (api.emit('add_to_cart_error', { operation_id: op ? op.id : api.uuid(), add_to_cart_source: source,
        cart_surface: op ? op.surface : cartSurface(event.target), error_type: status === 422 ? 'validation' : (status >= 500 ? 'server' : 'unknown') })) {
        if (detail.source === 'cart-gift-wrap') complete(op.id);
      }
    });
  });
  document.addEventListener('cart:updated', function (event) {
    var detail = event.detail || {};
    if (detail.source === 'cart-gift-wrap') giftRemoval(detail);
    acceptCart(detail.cart, !detail._rewardBarInternal);
  });
  document.addEventListener('change', function (event) {
    var control = event.target;
    if (!control.matches || !control.matches('[data-cart-gift-wrap-checkbox]') || control.disabled) return;
    var root = control.closest('[data-cart-gift-wrap]');
    if (!root || root.getAttribute('aria-busy') === 'true') return;
    var op = operation(control, null);
    if (op) { op.action = control.checked ? 'add' : 'remove'; op.quantity = 1; }
  }, true);
  ['cart:quantity.cart-cart-drawer', 'cart:quantity.cart-page', 'cart:quantity.cart-header'].forEach(function (name) {
    document.addEventListener(name, function (event) {
      if (!api.isAllowed()) return;
      var detail = event.detail || {}, key = Array.isArray(detail) ? detail[0] : detail.key;
      var qty = Number(Array.isArray(detail) ? detail[1] : detail.qty);
      if (!key || !Number.isInteger(qty) || qty < 0) return;
      if (!snapshot) { skipped('remove_from_cart', 'missing_before_cart'); return; }
      var before = snapshot.lines.find(function (line) { return line.key === key; });
      if (!before) { skipped('cart_quantity_change', 'missing_before_line'); return; }
      var matches = snapshot.lines.filter(function (line) {
        return !line.automatic && line.item.item_id === before.item.item_id && line.item.item_variant === before.item.item_variant;
      });
      intents.set(key, { quantity: qty, at: performance.now(), id: api.uuid(), surface: name.indexOf('page') >= 0 ? 'page' : 'drawer',
        before: before, currency: snapshot.currency, uniqueVariant: matches.length === 1 });
      if (intents.size > 200) intents.delete(intents.keys().next().value);
    });
  });
  function checkout(el) {
    if (!el || !el.matches) return false;
    if (el.matches('[name="checkout"], [data-pm-buy-now]')) return true;
    if (!el.matches('a[href]')) return false;
    try { var url = new URL(el.href, location.origin); return url.origin === location.origin && /\/checkout\/?$/.test(url.pathname); } catch (_) { return false; }
  }
  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;
    var button = event.target.closest('button, a[href], input[type="submit"]');
    if (!button || button.disabled) return;
    if (button.matches('[data-sticky-add-btn]')) { stickyClick = true; setTimeout(function () { stickyClick = false; }, 0); }
    if (button.matches(addSelector) && (!button.form || button.type !== 'submit')) operation(button, null);
    if (!api.isAllowed()) return;
    if (button.matches('.cart__remove a[href]') && snapshot) {
      var url = new URL(button.href, location.origin), key = url.searchParams.get('id');
      var line = snapshot.lines.find(function (entry) { return entry.key === key; });
      if (url.origin === location.origin && /\/cart\/change$/.test(url.pathname) && url.searchParams.get('quantity') === '0' && line && !line.automatic && /^[a-zA-Z0-9:._-]{1,180}$/.test(key)) {
        try { sessionStorage.setItem(removalKey, JSON.stringify({ key: key, item: line.item, currency: snapshot.currency, surface: cartSurface(button), id: api.uuid(), pageId: api.pageId(), at: Date.now() })); }
        catch (_) { skipped('remove_from_cart', 'remove_handoff_unavailable'); }
      }
    }
    if (checkout(button)) {
      api.emit('checkout_intent', { cart_surface: cartSurface(button), action: button.matches('[data-pm-buy-now]') ? 'buy_now' : 'click' });
      if (button.form) { var form = button.form; checkoutClicks.add(form); setTimeout(function () { checkoutClicks.delete(form); }, 0); }
    }
  }, true);
  document.addEventListener('submit', function (event) {
    if (!event.target.matches('form')) return;
    var form = event.target;
    if (/\/cart\/add(?:\.js)?(?:\?|$)/.test(form.action)) operation(event.submitter || form.querySelector(addSelector), form);
    if (!api.isAllowed()) return;
    if (!checkoutClicks.has(form) && (checkout(event.submitter) || (!event.submitter && /\/checkout\/?(?:\?|$)/.test(form.action)))) api.emit('checkout_intent', { cart_surface: cartSurface(form), action: 'submit' });
  }, true);
  function reset(allowed) {
    epoch++; revision++; if (controller) controller.abort(); controller = null; pending = null;
    operationStates.forEach(function (op) { Object.keys(op).forEach(function (key) { delete op[key]; }); op.blocked = true; });
    operationStates.clear();
    if (!allowed) clearRemoval();
    seen = new WeakSet(); checkoutClicks = new WeakSet(); completed.clear(); intents.clear(); snapshot = null; view = null; stickyClick = false;
    syncView();
  }
  api.onConsent(reset); api.onPageView(reset);
  document.addEventListener('drawerOpen.CartDrawer', syncView);
  document.addEventListener('visibilitychange', function () { if (document.visibilityState !== 'hidden') { syncView(); emitView(); } });
  new MutationObserver(syncView).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'aria-hidden'] });
  // A fresh document can still be waiting for Shopify's privacy API. Do not read
  // or discard the consented previous-page handoff until that decision resolves.
  if (api.hasConsentDecision && api.hasConsentDecision() && !api.isAllowed()) clearRemoval();
  syncView();
  api.registerModule('cart', function () { return { successBusSubscribed: true, giftWrapSubscribed: true, cartSnapshotAvailable: !!snapshot, pendingCartRead: !!pending, activeCartView: view ? view.surface : null, pendingQuantityChanges: intents.size }; });
})();
